import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import { FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa';
import InputField from '../FormFields/InputField';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ApiService from '../../helper/apiService';
import { APIS } from '../../apis';
import { toast } from 'react-toastify';



const SignIn = ({ onClose, showRoomPopUp, flowType, isActive }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMesssage] = useState("");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
   const navigate = useHistory();

  const togglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required('Email is Required'),
      password: Yup.string().required('Password is required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (isForgotPassword) {
        let forgot = await fogotPasswordCall(values);
        if (forgot?.suc) {
          setErrorMesssage(`Reset link sent to ${values?.email}`);
          setIsForgotPassword(false); // Go back to login after "reset"
        } else {
          setErrorMesssage(`Invalid emailid`);
        }
        setSubmitting(false);
        return;
      }
      let login_resp = await login(values);
      if (login_resp?.suc) {
        //If the schedule link clicked and not logged in scenario
        if (flowType && flowType === "show_room") {
          showRoomPopUp(true);
        } else {
          onClose(true);
          if (login_resp?.data?.isDoctor) {
            navigate.push("/doctor")
          } else {
            navigate.push("/patient")
          }
        }
      } else {
        toast.error("Invalid credentials")
      }
      setSubmitting(false);
    }
  });

  useEffect(() => {
    if (isActive) {
      setErrorMesssage("");
      formik.resetForm();
    }
  }, [isActive]);

  const login = async (payload) => {
    //const response = await ApiService.post(APIS.LOGIN_API, payload);
    let data = localStorage.getItem("signup");
    if (data !== undefined && data !== null && data !== "") {
      data = JSON.parse(data);
      let isValid = data?.filter((itm) => itm?.email === payload?.email?.trim());
      if (isValid?.length > 0) {
        localStorage.setItem("user", JSON.stringify(isValid[0]));
        return {
          suc: true,
          data: isValid[0]
        }
      } else {
        return {
          suc: false,
        }
      }
    } else {
      return {
        suc: false,
      }
    }
  }

  const fogotPasswordCall = async (values) => {
    /*  return await ApiService.post(APIS.FORGOT_PASSWORD_API, {
       email: values?.email
     }); */
    return {
      suc: true,
      data: {

      }
    }
  };

  return (
    <>
      <div className="mt-5 formWrap">
        <Row>
          <Col md={12}>
            <form onSubmit={formik.handleSubmit}>
              {isForgotPassword ? (
                <>
                  <div className='inputWrap'>
                    <label>Email</label>
                    <div className="input-group">
                      <InputField
                        name="email"
                        placeholder="Enter Email"
                        type="text"
                        icon={FaEnvelope}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.errors.email}
                        touched={formik.touched.email}
                      />
                      <FaEnvelope className="input-icon" />
                    </div>
                  </div>
                  <div className="buttonWrap">
                    <Button variant="primary" type="submit">
                      Submit
                    </Button>
                  </div>
                  <div className="forgot-password">
                    <a href="#" onClick={() => setIsForgotPassword(false)}>← Back to Login</a>
                  </div>
                </>
              ) : (
                <>
                  <div className='inputWrap'>
                    <label>Email</label>
                    <div className="input-group">
                      <InputField
                        name="email"
                        placeholder="Enter Email"
                        type="text"
                        icon={FaEnvelope}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.errors.email}
                        touched={formik.touched.email}
                      />
                      <FaEnvelope className="input-icon" />
                    </div>
                  </div>
                  <div className='inputWrap'>
                    <label>Password</label>
                    <div className="input-group">
                      <InputField
                        name="password"
                        placeholder="Enter Password"
                        type={showPassword ? 'text' : 'password'}
                        icon={showPassword ? FaEyeSlash : FaEye}
                        onIconClick={togglePassword}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.errors.password}
                        touched={formik.touched.password}
                      />
                      {showPassword ? (
                        <FaEyeSlash className="input-icon" onClick={togglePassword} />
                      ) : (
                        <FaEye className="input-icon" onClick={togglePassword} />
                      )}
                    </div>
                  </div>
                  {errorMsg &&
                    <div className="errorMessage">
                      {errorMsg}
                    </div>
                  }
                  <div className="forgotPassword">
                    <a href="#" onClick={() => setIsForgotPassword(true)}>Forgot Password?</a>
                  </div>
                  <div className="buttonWrap">
                    <Button variant="primary" type="submit">
                      Sign In
                    </Button>
                  </div>
                </>
              )}
            </form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SignIn;
